export const departmentPath = "/departments"
export const newDepartmentPath = "/departments/new"

export const buildEditDepartmentPath = id => `/departments/${id}/edit`
export const buildDeleteDepartmentPath = id => `/departments/${id}/delete`
